import type { FIXED_INDENTS } from "/app/libraries/arcana/src/vars/index.ts"

import type { JSX, SubmitEvent } from 'react'

import { AuthFormBoxInternalTemplate } from "/app/libraries/arcana/src/blocks/AuthFormBox/Templates/index.ts"
import { PrimarySubmitButton } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"
import { RememberMeWrapper } from "/app/libraries/arcana/src/blocks/AuthFormBox/index.ts"

import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import { $viewError, signInFx } from '../../model'
import { RememberMe } from '../../ui/RememberMe'
import { useSubmitLocked } from '../../ui/useSubmitLocked'
import { model as signInByEmailModel, translations } from '../model'
import { ForgotPasswordComponent } from './ForgotPasswordComponent'
import { LoginPasswordInputs } from './LoginPasswordInputs'

export interface SignInByEmailFormProps {
  forgotPasswordEnabled?: boolean
  rowGap?: FIXED_INDENTS[]
}

export const SignInByEmailForm = ({
  forgotPasswordEnabled,
  rowGap,
}: SignInByEmailFormProps): JSX.Element => {
  const formTranslations = useUnit(translations.$signInByEmailTranslations)

  const isSubmitting = useSubmitLocked(signInFx.pending, $viewError)
  const { submit, eachValid } = useForm(signInByEmailModel.signInForm)

  const onSubmit = (e: SubmitEvent<HTMLFormElement>) => {
    e.preventDefault()
    submit()
  }

  return (
    <form onSubmit={onSubmit} noValidate>
      <AuthFormBoxInternalTemplate rowGap={rowGap}>
        <LoginPasswordInputs isSubmitting={isSubmitting} />
        <RememberMeWrapper>
          <RememberMe disabled={isSubmitting} />
          {forgotPasswordEnabled && <ForgotPasswordComponent />}
        </RememberMeWrapper>
        <PrimarySubmitButton
          title={
            isSubmitting
              ? formTranslations.submittingTitle
              : formTranslations.submitTitle
          }
          disabled={isSubmitting || !eachValid}
          withLoader
          isLoading={isSubmitting}
          dataTestId='signin-btn'
        />
      </AuthFormBoxInternalTemplate>
    </form>
  )
}
